<template>
  <div>
    <pack>
      <zt-title>App管理</zt-title>
      <div class="search">
        <form @submit.native.prevent @keyup.enter.exact="onSeek">
          <span>App名称</span>
          <zt-input clearable v-model="seeker.app_name" placeholder="请输入App名称"></zt-input>
          <span>状态</span>
          <el-select v-model="seeker.status" placeholder="请选择">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span>淘客手机号码</span>
          <zt-input class="tel-input" clearable v-model="seeker.telephone" placeholder="请输入手机号码"></zt-input>
          <span>id</span>
          <zt-input clearable v-model="seeker.id" placeholder="请输入id"></zt-input>
          <zt-button type="primary" @click="onSeek" @keyup.enter="onSeek">搜索</zt-button>
          <zt-button class="clear-btn" @click="clean">清空</zt-button>
        </form>
      </div>
      <el-table :data="list">
        <el-table-column prop="id" label="id"></el-table-column>
        <el-table-column prop="app_name" label="App名称"></el-table-column>
        <el-table-column label="App图标">
          <template slot-scope="{ row }">
            <img class="app-icon" :src="row.app_icon" alt />
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{ row }">{{row.status==0?'开发中':'开发完成'}}</template>
        </el-table-column>
        <el-table-column label="过期时间">
          <template slot-scope="{ row }">{{formatDate(row.plugin_app_expires_at*1000)}}</template>
        </el-table-column>

        <el-table-column prop="telephone" label="淘客手机号"></el-table-column>
        <el-table-column prop="ios_demo_url" label="iOS下载地址"></el-table-column>
        <el-table-column prop="iosUpdataTime" label="最近更新时间"></el-table-column>
        <el-table-column prop="android_demo_url" label="Android(安卓)下载地址"></el-table-column>
        <el-table-column prop="androidUpdataTime" label="最近更新时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{ row }">
            <zt-button size="mini" @click="gotoDetail(row)">详情</zt-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="pagination.page"
          :page-sizes="pagesize"
          :page-size="pagination.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.recordcount"
        ></el-pagination>
      </div>
    </pack>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import { admin_plugin_app_list } from '@/api/appAdminManage';
export default {
  data: () => ({
    formatDate,
    seeker: {
      app_name: '',
      status: '',
      telephone: '',
      id: '',
    },
    stateOptions: [
      {
        label: '开发中',
        value: 0,
      },
      {
        label: '开发完成',
        value: 1,
      },
    ],
    list: [],
    pagesize: [10, 20, 30, 40],
    pagination: {
      page: 1, // 当前页
      pagesize: 10, // 每页大小
      pagecount: 1, // 总页数
      recordcount: 0, // 总条数
    },
  }),
  watch:{
    'seeker.telephone'(val) {
      if ((val+'').indexOf(' ') !== -1) {
        this.seeker.telephone = this.seeker.telephone.replace(/\s+/g, '');
      }
    },
  },
  methods: {
    onSeek() {
      this.pagination.page = 1;
      this.getList();
    },
    //app详情
    gotoDetail(row) {
      this.$router.push({
        path: `/appAdminManage/appDetail/${row.id}_${row.app_name}`,
      });
    },

    //获取数据
    getList() {
      admin_plugin_app_list({
        ...this.seeker,
        ...this.pagination,
      }).then(({ data }) => {
        if (data.error_code == 0) {
          this.list = data.list;
          this.pagination.pagecount = data.pagecount;
          this.pagination.recordcount = data.recordcount;
        }
      });
    },
    //清空
    clean() {
      this.seeker = {
        app_name: '',
        status: '',
        telephone: '',
        id: '',
      };
      this.getList();
    },
    // 更改 - 分页大小
    onSizeChange(pagesize) {
      this.pagination.pagesize = pagesize;
      this.getList();
    },

    // 更改 - 当前页
    onCurrentChange(page) {
      this.pagination.page = page;
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/table.scss";
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: #f7f2ff;
}
#app .el-table {
  /deep/.el-table--border th:first-child .cell,
  /deep/.el-table--border td:first-child .cell,
  /deep/ .cell {
    padding-left: 10px;
    text-overflow: unset;
  }
}

.search {
  margin-top: 18px;
  margin-bottom: 18px;
  .zt-input {
    width: 150px;
    margin-right: 40px;
  }
  span {
    font-size: 14px;
    color: rgba(35, 37, 38, 1);
    line-height: 20px;
    margin-right: 10px;
  }
  /deep/ .el-select {
    width: 140px;
    margin-right: 40px;
  }
  .clear-btn {
    margin-left: 16px;
  }
}
.app-icon {
  width: 64px;
  height: 64px;
}
</style>